export default "__VITE_PUBLIC_ASSET__c691bcbf__"